import request from '@/utils/request';

function getSeriesForWorkshop(domainID, workshopID, planningOption) {
  return request({
    method: 'get',
    url: 'productionplanningseries/makeSeriesForWorkshop',
    params: {
      domainID: domainID,
      workshopID: workshopID,
      planningOption: planningOption
    },
    timeout: 120000
  });
}

function finishSeriesForWorkshop(domainID, workshopID, planningOption) {
  return request({
    data: { domainID, workshopID, planningOption },
    method: 'post',
    url: 'productionplanningseries/finishSeriesForProductGroup',
    timeout: 120000
  });
}

function getSeries(seriesID) {
  return request({
    method: 'get',
    url: 'productionplanningseries/getSeries',
    params: {
      seriesID: seriesID
    }
  });
}

function updateSeriesOrderLineStatusesWithStatus(seriesID, fromStatusID, toStatusID, estimatedDeliveryDate, selection) {
  return request({
    data: { seriesID, selection, fromStatusID, toStatusID, estimatedDeliveryDate },
    method: 'post',
    url: 'productionplanningseries/updateSeriesOrderLineStatusesWithStatus'
  });
}

function deleteSelectedOrderLinesFromSeries(seriesID, selection) {
  return request({
    data: { seriesID, selection },
    method: 'post',
    url: 'productionplanningseries/deleteSelectedOrderLinesFromSeries'
  });
}

function addOrderNumberToSeries(seriesID, orderNumber) {
  return request({
    data: { seriesID, orderNumber },
    method: 'post',
    url: 'productionplanningseries/addOrderNumberToSeries'
  });
}

export function printTickets(printCommand) {
  return request({
    data: printCommand,
    method: 'post',
    url: 'productionplanningseries/printTickets',
    timeout: 120000
  });
}

export function getPrintStatus(seriesID) {
  return request({
    method: 'get',
    url: 'productionplanningseries/getPrintStatus',
    params: {
      seriesID: seriesID
    }
  });
}

export function getAvailableWeeks(workshopIDs, domainID, year) {
  return request({
    method: 'get',
    url: 'productionplanningseries/getAvailableWeeks',
    params: {
      workshopIDsAsString: workshopIDs,
      domainID: domainID,
      year: year
    }
  });
}

export function getStatusList(workshopID, domainID, year, weeks, series, report, page, pageSize) {
  return request({
    method: 'get',
    url: 'productionplanningseries/statuslist',
    params: {
      workshopID: workshopID,
      domainID: domainID,
      year: year,
      weeks: weeks,
      series: series,
      report: report,
      page: page,
      pageSize: pageSize
    }
  });
}

export function downloadStatusList(workshopID, domainID, year, weeks, series, report) {
  return request({
    method: 'get',
    url: 'productionplanningseries/statuslist/excel',
    params: {
      workshopID: workshopID,
      domainID: domainID,
      year: year,
      weeks: weeks,
      series: series,
      report: report
    },
    responseType: 'blob'
  });
}
export function download(params) {
  return request({
    method: 'get',
    url: 'productionplanningseries/excel',
    params: params && params.query,
    responseType: 'blob'
  });
}

export function downloadComponentList(workshops, domainID, year, weeks, series) {
  return request({
    method: 'get',
    url: 'productionplanningseries/componentlist/excel',
    params: {
      workshopIDs: workshops,
      domainID: domainID,
      year: year,
      weeks: weeks,
      seriesIDs: series
    },
    responseType: 'blob'
  });
}

export function getAvailableSeries(workshopIDs, domainID, year, weeks) {
  return request({
    method: 'get',
    url: 'productionplanningseries/getAvailableSeries',
    params: {
      workshopIDsAsString: workshopIDs,
      domainID: domainID,
      year: year,
      weeksAsString: weeks
    }
  });
}

export function getComponentList(workshopIDs, domainID, year, weeks, series) {
  return request({
    method: 'get',
    url: 'productionplanningseries/getComponentList',
    params: {
      workshopIDsAsString: workshopIDs,
      domainID: domainID,
      year: year,
      weeksAsString: weeks,
      series: series
    }
  });
}

export const storeExtensions = {
  actions: {
    getSeriesForWorkshop({ dispatch }, { domainID, workshopID, planningOption }) {
      return new Promise((resolve, reject) =>
        getSeriesForWorkshop(domainID, workshopID, planningOption)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    finishSeriesForWorkshop({ dispatch }, { domainID, workshopID, planningOption }) {
      return new Promise((resolve, reject) =>
        finishSeriesForWorkshop(domainID, workshopID, planningOption)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    getSeries({ dispatch }, { seriesID }) {
      return new Promise((resolve, reject) =>
        getSeries(seriesID)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    updateSeriesOrderLineStatusesWithStatus(
      { dispatch },
      { seriesID, selection, fromStatusID, toStatusID, estimatedDeliveryDate }
    ) {
      return new Promise((resolve, reject) =>
        updateSeriesOrderLineStatusesWithStatus(seriesID, fromStatusID, toStatusID, estimatedDeliveryDate, selection)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    deleteSelectedOrderLinesFromSeries({ dispatch }, { seriesID, selection }) {
      return new Promise((resolve, reject) =>
        deleteSelectedOrderLinesFromSeries(seriesID, selection)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    addOrderNumberToSeries({ dispatch }, { seriesID, orderNumber }) {
      return new Promise((resolve, reject) =>
        addOrderNumberToSeries(seriesID, orderNumber)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    printTickets({ commit, dispatch }, printCommand) {
      return new Promise((resolve, reject) =>
        printTickets(printCommand)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    getPrintStatus({ dispatch }, { seriesID }) {
      return new Promise((resolve, reject) =>
        getPrintStatus(seriesID)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    getAvailableWeeks({ dispatch }, { workshopIDs, domainID, year }) {
      return new Promise((resolve, reject) =>
        getAvailableWeeks(workshopIDs, domainID, year)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    getStatusList({ dispatch }, { workshopID, domainID, year, weeks, series, report, page, pageSize }) {
      return new Promise((resolve, reject) =>
        getStatusList(workshopID, domainID, year, weeks, series, report, page, pageSize)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    download({ dispatch }, params) {
      return new Promise((resolve, reject) =>
        download(params)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    downloadStatusList({ dispatch }, { workshopID, domainID, year, weeks, series, report }) {
      return new Promise((resolve, reject) =>
        downloadStatusList(workshopID, domainID, year, weeks, series, report)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    downloadComponentList({ dispatch }, { workshopIDs, domainID, year, weeks, series }) {
      return new Promise((resolve, reject) =>
        downloadComponentList(workshopIDs, domainID, year, weeks, series)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    getAvailableSeries({ dispatch }, { workshopIDs, domainID, year, weeks }) {
      return new Promise((resolve, reject) =>
        getAvailableSeries(workshopIDs, domainID, year, weeks)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    getComponentList({ dispatch }, { workshopIDs, domainID, year, weeks, series }) {
      return new Promise((resolve, reject) =>
        getComponentList(workshopIDs, domainID, year, weeks, series)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    }
  }
};
